import JsEncrypt from 'jsencrypt'
import config from '@/config/defaultSettings'
/**
 * RSA加密
 * @param {string} str 待加密串
 * @param {string} key 公钥
 * @returns {string}
 */
const jse = new JsEncrypt()
export function encryption (str) {
  const key = config.production ? config.proPubKey : config.testPubKey
  jse.setPublicKey(key)
  return jse.encrypt(str)
}
